import { useFlag } from "@unleash/proxy-client-react";
import { UnleashFlags } from "../../../../constants";

export function useSbpTransferAllowed(): boolean {
  const globalOn = useFlag(UnleashFlags.sbpTransferEnabled);
  const whiteListed = useFlag(UnleashFlags.sbpTransferWhiteList);

  return globalOn || whiteListed;
}
